<template lang="pug">
  v-text-field(
    v-model="maskedValue"
    v-maska:[options]
    v-bind="extendAttrs"
    v-on="extendListeners"
  )
</template>

<script>
import { vMaska } from 'maska';

const TYPE_DATA = {
  snils: {
    fieldAttrs: {
      label: 'СНИЛС',
      placeholder: '123-456-789 01',
      persistentPlaceholder: true,
    },
    options: {
      mask: '###-###-### ##',
    },
  },
  phone: {
    fieldAttrs: {
      label: 'Телефон',
      prefix: '+',
      type: 'phone',
      placeholder: '7 (123) 456-78-90',
      persistentPlaceholder: true,
    },
    options: {
      mask: '# (###) ###-##-##',
    },
  },
};

export default {
  name: 'MaskaField',
  directives: { maska: vMaska },
  props: {
    mask: { type: String, default: '' },
    type: { type: String, default: undefined },
    returnMasked: { type: Boolean, default: false },
    syncValue: { type: Boolean, default: false },
  },
  data() {
    return {
      maskedValue: this.$attrs.value,
    };
  },
  computed: {
    typeData() {
      const { type } = this;
      return TYPE_DATA[type] ?? {};
    },
    options() {
      const { mask, typeData: { options }, returnMasked } = this;
      return {
        mask,
        onMaska: (attrs) => {
          const { masked, unmasked } = attrs;
          if (returnMasked) this.$emit('input', masked);
          else this.$emit('input', unmasked);
          this.$emit('maska', attrs);
        },
        ...options ?? {},
      };
    },
    extendAttrs() {
      const { $attrs, typeData: { fieldAttrs } } = this;
      return {
        ...fieldAttrs ?? {},
        ...$attrs,
      };
    },
    extendListeners() {
      const { $listeners } = this;
      const newListeners = {
        ...$listeners,
      };
      delete newListeners.input;
      return newListeners;
    },
  },
  watch: {
    '$attrs.value': {
      handler(v) {
        if (this.syncValue) this.maskedValue = v;
      },
    },
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
::v-deep input {
    letter-spacing: none;

    &::placeholder {
    letter-spacing: none;
  }
}
</style>
